<template>
  <div class="questionnaire-question-content">
    <div class="questionnaire-question-question">
      {{ statement }}
      <div v-if="audio != '' && audio != null" class="questionnaire-question-image" @click.prevent="playSound()">
        <img src="@/assets/img/listen.png">
      </div>
      <div v-if="image != null && image != ''" class="questionnaire-question-explanation">
        <img :src="require(`@/assets/img/question/${image}`)">
      </div>
    </div>

    <div id="actualSentence" class="questionnaire-question-sentence"></div>

    <div class="questionnaire-question-response">
      <div class="form-group">
        <Field id="wordResponse" autocapitalize="none" autocomplete="off" class="questionnaire-question-response-input" name="text" spellcheck="false" type="hidden" @change="changeOnField($event)"/>
        <ErrorMessage class="error-feedback" name="email"/>
        <span id="error-regex" class="text-danger"></span>
      </div>
    </div>
    <div v-if="audioCurrentTime !== '' && audioCurrentTime != null" class="questionnaire-question-question"><br/>Durée de l'audio : {{ audioCurrentTime }} / {{ audioDuration }} s</div>
  </div>
</template>

<script>
import {ErrorMessage, Field} from "vee-validate";
import UserService from "@/services/user.service";
import {nextTick} from "vue";

export default {
  name: "ExpressionModifyUnderscore",
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    question: String,
    statement: String,
    audio: String,
    image: String,
    regex: String,
    error: Boolean
  },
  data() {
    return {
      idElement: null,
      initialSentence: "",
      actualSentence: null,
      consigne: null,
      answer: null,
      domainId: this.$parent.domainId,
      indexQuestion: this.$parent.indexQuestion,
      listen: this.$parent.listen,
      audioDuration: '',
      audioCurrentTime: ''
    }
  },
  methods: {
    addSpan: function (sentence) {
      var reg = /word[0-9]?[0-9]?[0-9]/g
      var array = sentence.match(reg)
      array.forEach((word) => {
        document.getElementById(word).addEventListener("click", this.selectWord, false);
      });
    },
    changeOnField: function (event) {
      let value = event.target.value;
      if (value != '') {
        if (this.indexQuestion === 39 && this.domainId === 3) {
          if (value.length > 1) {
            value = value[0].toUpperCase() + value.slice(1).toLowerCase()
          }
        }

        // Lorsqu'on rafraichit la page ou lorsqu'on fait suivant / précédent
        document.getElementById(this.idElement).textContent = event.target.value;
        document.getElementById('wordResponse').value = '';
        document.getElementById('wordResponse').type = 'hidden';
        this.actualSentence = this.replaceSentence(" ", this.initialSentence)

        let html = document.getElementById('actualSentence').innerHTML
        document.getElementById('error-regex').innerHTML = '';
        this.answer = html.replace(/<\/?span[^>]*>/g, "")
        this.idElement = null
        this.$emit('update:error', false)

      } else {
        document.getElementById('error-regex').innerHTML = '';
      }
    },
    disableClick: function (time) {
      time = time * 1000
      var element = document.getElementById('questionContent');
      element.classList.add('questionnaire-question-disable');
      setTimeout(
          function () {
            element.classList.remove('questionnaire-question-disable');
          }, time
      )
    },
    playSound() {
      document.getElementById('wordResponse').type = 'hidden';
      this.idElement = null


      var audioInstance = new Audio(require('@/assets/sounds/' + this.audio))
      var _ = this;

      audioInstance.addEventListener('loadedmetadata', function () {
        audioInstance.setAttribute('data-time', audioInstance.duration);
        _.audioDuration = audioInstance.duration.toFixed(1);
      }, false);

      audioInstance.play().then(() => {
        this.disableClick(audioInstance.duration)
        this.$parent.remainingTime = this.$parent.remainingTime + Math.floor(audioInstance.duration)
        this.$parent.saveListen(this.$parent.listen)
      })

      audioInstance.addEventListener("timeupdate", function () {
        _.audioCurrentTime = (audioInstance.currentTime % 60).toFixed(1);
      }, false);


    },
    findAndReplaceWord: function (words, wordsAnswer) {
      // On va recherche les underscrore présent dans la phrase intitiale
      // on recherche dans la réponse en base, les mots qui ont été saisi
      // lorsque plusieurs mots sont dans les élements de réponse
      // le tableau de réponse se retrouve décallé
      // Ex : Je que ___ chat est ___.
      // Ex : Je que ce con de chat est con comme la lune.
      // Le mot est : se trouve en position 5 intialement
      // mais dans la réponse, il se trouve en position 7
      let decalage = 0;
      words.forEach((word, index) => {
        if (word.search("___") !== -1) {
          let startSearch = index + decalage;
          let newWord = "";
          for (let i = startSearch; i < wordsAnswer.length; i++) {
            newWord = newWord + wordsAnswer[i];
            if (wordsAnswer[i + 1] == words[index + 1]) {
              newWord = '<span  class="questionnaire-question-sentence-focus" id="word' + index + '">' + newWord + '</span>'
              words[index] = newWord;
              break;
            }
            newWord = newWord + " ";
            decalage++;
          }
        }
      })
      return words;
    },
    replaceSentence: function (split, sentence) {
      let wordsSentence = sentence.split(split);
      let wordsAnswer = [];
      let words = wordsSentence;
      if (this.answer !== null) {
        wordsAnswer = this.answer.split(split);
      }
      wordsSentence.forEach((word, index) => {
        wordsSentence[index] = word.replace("___", '<span  class="questionnaire-question-sentence-focus" id="word' + index + '">___</span>');
      });
      wordsAnswer.forEach((word, index) => {
        wordsAnswer[index] = word.replace("___", '<span  class="questionnaire-question-sentence-focus" id="word' + index + '">___</span>');
      });
      if (this.answer !== null) {
        words = this.findAndReplaceWord(wordsSentence, wordsAnswer);
      }
      return words.join(split);
    },
    selectWord: function (event) {
      var word = ""

      if (event.target.textContent != "___") {
        word = event.target.textContent
        document.getElementById('wordResponse').value = word
      }
      this.idElement = event.target.id
      document.getElementById('wordResponse').type = 'text';
      document.getElementById('wordResponse').value = word;
      document.getElementById("wordResponse").focus();
    }
  },
  mounted() {
    this.listen = this.$parent.listen
    this.initialSentence = this.question

    UserService.getUserTestQuestions(this.domainId).then(
        (response) => {
          /* Au chargement de la question */
          var arrayResponses = response.data.responses
          var index = (this.indexQuestion - 1)
          this.answer = null
          if (arrayResponses[index] !== undefined) {
            this.answer = arrayResponses[index]['answer']
          }
          this.actualSentence = this.replaceSentence(" ", this.initialSentence)
          document.getElementById('actualSentence').innerHTML = this.actualSentence;
          this.addSpan(this.actualSentence)
          nextTick(()=>{
            this.$parent.pageIsLoaded = true
          })
        }
    );
  },
};
</script>
